import { render, staticRenderFns } from "./ConfirmForgotPasswordForm.vue?vue&type=template&id=4ddf8242&scoped=true"
import script from "./ConfirmForgotPasswordForm.vue?vue&type=script&lang=js"
export * from "./ConfirmForgotPasswordForm.vue?vue&type=script&lang=js"
import style0 from "./ConfirmForgotPasswordForm.vue?vue&type=style&index=0&id=4ddf8242&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddf8242",
  null
  
)

export default component.exports